// ============================================================================
// QUICK SORT - ALGORITHM METADATA
// ============================================================================

export const meta = {
  id: 'quick-sort',
  name: 'Quick Sort',
  category: 'Sorting',
  complexity: {
    time: 'O(n log n) average, O(n²) worst',
    space: 'O(log n)'
  },
  description: 'A divide-and-conquer sorting algorithm that selects a pivot element and partitions the array around it, such that elements less than the pivot are on one side and elements greater are on the other. It then recursively sorts the sub-arrays.'
};
